import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card, Col, Nav, Row, } from 'react-bootstrap';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import { useAppContext } from 'providers/AppProvider';
import SimpleBar from 'simplebar-react';
import LoaderInfiniteLoop from 'widgets/loaderInfiniteLoop';
import IconAlert from 'components/common/IconAlert';
import Flex from 'components/common/Flex';

import { Axios } from 'helpers/axios';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { formDemandeDPS1, formDemandeDPS2, formDemandeDPS3, formDemandeDPS4, formDemandeDPSLight1, formDemandeDPSLight2 } from 'helpers/yupValidationSchema';

import DemandeDPSStep1 from './full/demandeDpsStep1';
import DemandeDPSStep2 from './full/demandeDpsStep2';
import DemandeDPSStep3 from './full/demandeDpsStep3';
import DemandeDPSStep4 from './full/demandeDpsStep4';
import DemandeDPSStep5 from './full/demandeDpsStep5';
import DemandeDPSStep6 from './full/demandeDpsStep6';

import DemandeDPSLightStep1 from './light/demandeDpsLightStep1';
import DemandeDPSLightStep2 from './light/demandeDpsLightStep2';
import DemandeDPSLightStep3 from './light/demandeDpsLightStep3';

const NavItem = ({ index, step, icon, label, nbSteps }) => {
  return (
    <Nav.Item>
      <Nav.Link
        className={classNames('fw-semibold', {
          done: index < nbSteps ? step > index : step > nbSteps-1,
          active: step === index
        })}
        disabled
      >
        <span className="nav-item-circle-parent">
          <span className="nav-item-circle">
            <FontAwesomeIcon icon={icon} />
          </span>
        </span>
        <span className="d-none d-md-block mt-1 fs-10">{label}</span>
      </Nav.Link>
    </Nav.Item>
  );
};

const DemandeDPS = () => {
    let { demandeUpdateCode } = useParams();
    const [showCloseState, setShowCloseState] = useState(false);
    const [showShortRequest, setShowShortRequest] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    let variant = null;

    const { isRTL } = useAppContext();

    const { register: register1, handleSubmit: handleSubmit1, formState: { errors: errors1 }, setValue: setValue1, reset: reset1, watch: watch1 } = useForm({
        resolver: yupResolver(formDemandeDPS1),
        mode: 'onBlur',
    });
    const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, setValue: setValue2, reset: reset2, watch: watch2 } = useForm({
        resolver: yupResolver(formDemandeDPS2),
        mode: 'onBlur',
    });
    const { register: register3, handleSubmit: handleSubmit3, formState: { errors: errors3 }, setValue: setValue3, reset: reset3, watch: watch3 } = useForm({
        resolver: yupResolver(formDemandeDPS3),
        mode: 'onBlur',
    });
    const { handleSubmit: handleSubmit4, setValue: setValue4, reset: reset4, watch: watch4 } = useForm({
        resolver: yupResolver(formDemandeDPS4),
        mode: 'onBlur',
    });

    const { register: registerLight1, handleSubmit: handleSubmitLight1, formState: { errors: errorsLight1 }, setValue: setValueLight1, reset: resetLight1, watch: watchLight1 } = useForm({
        resolver: yupResolver(formDemandeDPSLight1),
        mode: 'onBlur',
    });
    const { register: registerLight2, handleSubmit: handleSubmitLight2, formState: { errors: errorsLight2 }, setValue: setValueLight2, reset: resetLight2, watch: watchLight2 } = useForm({
        resolver: yupResolver(formDemandeDPSLight2),
        mode: 'onBlur',
    });

    const [step, setStep] = useState(1);
    const navItems = [
        {
            icon: 'building-user',
            label: 'Qui êtes vous ?'
        },
        {
            icon: 'calendar-check',
            label: 'Votre évènement'
        },
        {
            icon: 'person-circle-question',
            label: 'Vos convives'
        },
        {
            icon: 'paperclip',
            label: 'Documents'
        },
        {
            icon: 'eye',
            label: 'Récapitulatif'
        },
        {
            icon: 'thumbs-up',
            label: "C'est parti !"
        }
    ];
    const navItemsLight = [
        {
            icon: 'building-user',
            label: 'Qui êtes vous ?'
        },
        {
            icon: 'calendar-check',
            label: 'Votre évènement'
        },
        {
            icon: 'phone',
            label: "On vous rappelle !"
        }
    ];

    const avancerStep = () => {
        if (step !== navItems.length) {
            if(step === 1)
            {
                handleSubmit1(nextStep)();
            }
            if(step === 2)
            {
                handleSubmit2(nextStep)();
            }
            if(step === 3)
            {
                handleSubmit3(nextStep)();
            }
            if(step === 4)
            {
                handleSubmit4(nextStep)();
            }
            if(step === 5)
            {
                nextStep();
            }
        }
    };

    const avancerStepLight = () => {
        if (step !== navItems.length) {
            if(step === 1)
            {
                handleSubmitLight1(nextStep)();
            }
            if(step === 2)
            {
                handleSubmitLight2(nextStep)();
            }
        }
    };

    const nextStep = () => {
        if(step === 1)
        {
            setValue1("step1", true);
        }
        if(step === 2)
        {
            setValue2("step2", true);
        }
        if(step === 3)
        {
            setValue3("step3", true);
        }
        if(step === 4)
        {
            setValue4("step4", true);
        }
        setStep(step+1);
    }

    useEffect(()=>{
        window.scrollTo(0, 0);
    },[step])

    const jumpToStep = (targetStep) => {
        setStep(targetStep);
    }

    const resetForm = () => {
        setIsLoading(true);
        setShowShortRequest(undefined);
        reset1();
        reset2();
        reset3();
        reset4();
        resetLight1();
        resetLight2();
        setStep(1);
        location.reload();
    }

    const initFromBrouillon = async () => {
        try {
            setShowShortRequest(false);
            
            const getOneDPS = await Axios.post('/publicRoutes/getDemandeBrouillon',{
                demandeUpdateCode: demandeUpdateCode,
            });

            setValue1("idStructureClient"            , getOneDPS.data.demande.idStructureClient             || null);
            setValue1("orgaRaisonSociale"            , getOneDPS.data.demande.orgaRaisonSociale             || null);
            setValue1("orgaAdresse"                  , getOneDPS.data.demande.orgaAdresse                   || null);
            setValue1("orgaRepresentantLegal"        , getOneDPS.data.demande.orgaRepresentantLegal         || null);
            setValue1("orgaRepresentantLegalFonction", getOneDPS.data.demande.orgaRepresentantLegalFonction || null);
            setValue1("orgaRepresentantLegalMail"    , getOneDPS.data.demande.orgaRepresentantLegalMail     || null);
            setValue1("orgaRepresentantLegalTel"     , getOneDPS.data.demande.orgaRepresentantLegalTel      || null);
            setValue1("orgaRepresentePar"            , getOneDPS.data.demande.orgaRepresentePar             || null);
            setValue1("orgaRepresenteParFonction"    , getOneDPS.data.demande.orgaRepresenteParFonction     || null);
            setValue1("orgaRepresenteParMail"        , getOneDPS.data.demande.orgaRepresenteParMail         || null);
            setValue1("orgaRepresenteParTel"         , getOneDPS.data.demande.orgaRepresenteParTel          || null);
            setValue1("orgaFacturationMail"          , getOneDPS.data.demande.orgaFacturationMail           || null);
            setValue1("orgaFacturationTel"           , getOneDPS.data.demande.orgaFacturationTel            || null);
            setValue1("orgaContactLocal"             , getOneDPS.data.demande.orgaContactLocal              || null);
            setValue1("orgaContactLocalFonction"     , getOneDPS.data.demande.orgaContactLocalFonction      || null);
            setValue1("orgaContactLocalTel"          , getOneDPS.data.demande.orgaContactLocalTel           || null);
            setValue2("libelleEvenement"             , getOneDPS.data.demande.libelleEvenement              || null);
            setValue2("activiteEvenement"            , getOneDPS.data.demande.activiteEvenement             || null);
            setValue2("dateDebutEvenement"           , getOneDPS.data.demande.dateDebutEvenement ? new Date(getOneDPS.data.demande.dateDebutEvenement) : null);
            setValue2("manifNomLieu"                 , getOneDPS.data.demande.manifNomLieu                  || null);
            setValue2("manifAdresse"                 , getOneDPS.data.demande.manifAdresse                  || null);
            setValue2("manifCP"                      , getOneDPS.data.demande.manifCP                       || null);
            setValue2("manifVille"                   , getOneDPS.data.demande.manifVille                    || null);
            setValue2("manifInternational"           , getOneDPS.data.demande.manifInternational            || false);
            setValue2("manifSurVP"                   , getOneDPS.data.demande.manifSurVP                    || false);
            setValue2("manifSurVPFermee"             , getOneDPS.data.demande.manifSurVPFermee              || false);
            setValue2("manifCircuit"                 , getOneDPS.data.demande.manifCircuit                  || false);
            setValue2("manifCircuitCarrossable"      , getOneDPS.data.demande.manifCircuitCarrossable       || false);
            setValue2("manifE1Accessibilite"         , getOneDPS.data.demande.manifE1Accessibilite          || null);
            setValue2("manifRisqueSite"              , getOneDPS.data.demande.manifRisqueSite               || null);
            setValue2("manifE2DelaisSP"              , getOneDPS.data.demande.manifE2DelaisSP               || null);
            setValue2("manifSPproches"               , getOneDPS.data.demande.manifSPproches                || null);
            setValue2("manifCHUproches"              , getOneDPS.data.demande.manifCHUproches               || null);
            setValue2("manifRemarques"               , getOneDPS.data.demande.manifRemarques                || null);
            setValue2("accueilAutreAASC"             , getOneDPS.data.demande.accueilAutreAASC              || false);
            setValue2("accueilAutreAASCDetails"      , getOneDPS.data.demande.accueilAutreAASCDetails       || null);
            setValue2("accueilSME"                   , getOneDPS.data.demande.accueilSME                    || false);
            setValue2("accueilSMEDetails"            , getOneDPS.data.demande.accueilSMEDetails             || null);
            setValue2("accueilMedicalAutreSME"       , getOneDPS.data.demande.accueilMedicalAutreSME        || false);
            setValue2("accueilAP"                    , getOneDPS.data.demande.accueilAP                     || false);
            setValue2("accueilSAMU"                  , getOneDPS.data.demande.accueilSAMU                   || false);
            setValue2("accueilSP"                    , getOneDPS.data.demande.accueilSP                     || false);
            setValue2("accueilSecuPrivee"            , getOneDPS.data.demande.accueilSecuPrivee             || false);
            setValue2("accueilFDO"                   , getOneDPS.data.demande.accueilFDO                    || false);
            setValue2("accueilRadioOrga"             , getOneDPS.data.demande.accueilRadioOrga              || false);
            setValue2("accueilLocauxIS"              , getOneDPS.data.demande.accueilLocauxIS               || false);
            setValue2("accueilTenteIS"               , getOneDPS.data.demande.accueilTenteIS                || false);
            setValue2("accueilMobilierIS"            , getOneDPS.data.demande.accueilMobilierIS             || null);
            setValue2("accueilElectricite"           , getOneDPS.data.demande.accueilElectricite            || false);
            setValue2("accueilEau"                   , getOneDPS.data.demande.accueilEau                    || false);
            setValue2("accueilChauffage"             , getOneDPS.data.demande.accueilChauffage              || false);
            setValue2("accueilLumiere"               , getOneDPS.data.demande.accueilLumiere                || false);
            setValue2("accueilRepas"                 , getOneDPS.data.demande.accueilRepas                  || false);
            setValue2("accueilEauCanicule"           , getOneDPS.data.demande.accueilEauCanicule            || false);
            setValue2("accueilReposIS"               , getOneDPS.data.demande.accueilReposIS                || false);

            if(getOneDPS.data.parties && getOneDPS.data.parties.length > 0)
            {
                let tempArray = [];
                let j = 1;
                for(const partie of getOneDPS.data.parties)
                {
                    tempArray.push({
                        ...partie,
                        id: j,
                        dateDebutPartieEvenement: partie.dateDebutPartieEvenement ? new Date(partie.dateDebutPartieEvenement) : null,
                        dateDebutPartieSecours: partie.dateDebutPartieSecours ? new Date(partie.dateDebutPartieSecours) : null,
                        dateFinPartieEvenement: partie.dateFinPartieEvenement ? new Date(partie.dateFinPartieEvenement) : null,
                        dateFinPartieSecours: partie.dateFinPartieSecours ? new Date(partie.dateFinPartieSecours) : null,
                        venteAlcool: partie.venteAlcool ? true : false,
                        pyrotechnie: partie.pyrotechnie ? true : false,
                        enginsMotrises: partie.enginsMotrises ? true : false,
                        publicPresent: partie.effectifPublicP1 > 0 ? true : false,
                        acteurPresent: partie.effectifActeurs > 0 ? true : false,
                    })
                    j=j+1;
                }
                setValue3("parties", tempArray);
            }

            setIsLoading(false);
        } catch (error) {
            setShowCloseState(true);
            setIsLoading(false);
        }
    }

    useEffect(()=>{
        if(demandeUpdateCode && demandeUpdateCode != null)
        {
            initFromBrouillon();
        }else{
            setIsLoading(false);
        }
    },[])

    if(isLoading)
    {
        return <LoaderInfiniteLoop />
    }else{
        if(showCloseState)
        {
            return <IconAlert variant={'info'}>Cette demande de DPS est déjà soumise, elle ne peut plus être modifiée.</IconAlert>
        }else{
            if(showShortRequest === true)
            {
                return (<>
                    <Card className="theme-wizard mt-3">
                        <Card.Header
                            className={classNames('bg-body-tertiary', {
                                'px-4 py-3': variant === 'pills',
                                'pb-2': !variant
                            })}
                        >
                            <center><h4 className='mb-3'>Votre demande de DPS</h4></center>
                            <SimpleBar>
                                <Nav className="justify-content-center" variant={variant}>
                                    {navItemsLight.map((item, index) => (
                                        <NavItem
                                            key={item.label}
                                            index={index + 1}
                                            step={step}
                                            icon={item.icon}
                                            label={item.label}
                                            nbSteps={navItemsLight.length}
                                        />
                                    ))}
                                </Nav>
                            </SimpleBar>
                        </Card.Header>

                        <Card.Body className="fw-normal px-md-6 py-4">
                            {step === 1 && (
                                <DemandeDPSLightStep1
                                    register={registerLight1}
                                    errors={errorsLight1}
                                    setValue={setValueLight1}
                                />
                            )}
                            {step === 2 && (
                                <DemandeDPSLightStep2
                                    register={registerLight2}
                                    errors={errorsLight2}
                                    setValue={setValueLight2}
                                    watch={watchLight2}
                                />
                            )}
                            {step === 3 && (
                                <DemandeDPSLightStep3
                                    watch1={watchLight1}
                                    watch2={watchLight2}
                                    resetForm={resetForm}
                                />
                            )}
                        </Card.Body>

                        <Card.Footer
                            className={classNames('px-md-6 bg-body-tertiary', {
                                'd-none': step === navItemsLight.length,
                                ' d-flex': step < navItemsLight.length
                            })}
                        >
                            <IconButton
                                variant="link"
                                icon={isRTL ? 'chevron-right' : 'chevron-left'}
                                iconAlign="left"
                                transform="down-1 shrink-4"
                                className={classNames('px-0 fw-semibold', {
                                    'd-none': step === 1
                                })}
                                onClick={() => {
                                    setStep(step - 1);
                                }}
                            >
                                Retour
                            </IconButton>
                            
                            { step === navItemsLight.length -1 ?
                                <IconButton
                                    variant="success"
                                    className="ms-auto px-5"
                                    icon={isRTL ? 'chevron-left' : 'chevron-right'}
                                    iconAlign="right"
                                    transform="down-1 shrink-4"
                                    onClick={avancerStepLight}
                                >
                                    ETRE RAPPELE
                                </IconButton>
                            :
                                <IconButton
                                    variant="primary"
                                    className="ms-auto px-5"
                                    icon={isRTL ? 'chevron-left' : 'chevron-right'}
                                    iconAlign="right"
                                    transform="down-1 shrink-4"
                                    onClick={avancerStepLight}
                                >
                                    Suivant
                                </IconButton>
                            }
                        </Card.Footer>
                    </Card>
                </>)
            }else{
                if(showShortRequest === false)
                {
                    return (<>
                        <Card className="theme-wizard mt-3">
                            <Card.Header
                                className={classNames('bg-body-tertiary', {
                                    'px-4 py-3': variant === 'pills',
                                    'pb-2': !variant
                                })}
                            >
                                <center><h4 className='mb-3'>Votre demande de DPS</h4></center>
                                <SimpleBar>
                                    <Nav className="justify-content-center" variant={variant}>
                                        {navItems.map((item, index) => (
                                            <NavItem
                                                key={item.label}
                                                index={index + 1}
                                                step={step}
                                                icon={item.icon}
                                                label={item.label}
                                                nbSteps={navItems.length}
                                            />
                                        ))}
                                    </Nav>
                                </SimpleBar>
                            </Card.Header>

                            <Card.Body className="fw-normal px-md-6 py-4">
                                {step === 1 && (
                                    <DemandeDPSStep1
                                        register={register1}
                                        errors={errors1}
                                        setValue={setValue1}
                                        watch={watch1}
                                    />
                                )}
                                {step === 2 && (
                                    <DemandeDPSStep2
                                        register={register2}
                                        errors={errors2}
                                        setValue={setValue2}
                                        watch={watch2}
                                    />
                                )}
                                {step === 3 && (
                                    <DemandeDPSStep3
                                        register={register3}
                                        errors={errors3}
                                        setValue={setValue3}
                                        watch={watch3}
                                        step2watch={watch2}
                                    />
                                )}
                                {step === 4 && (
                                    <DemandeDPSStep4
                                        setValue={setValue4}
                                        watch={watch4}
                                    />
                                )}
                                {step === 5 && (
                                    <DemandeDPSStep5
                                        watch1={watch1}
                                        watch2={watch2}
                                        watch3={watch3}
                                        watch4={watch4}
                                        jumpToStep={jumpToStep}
                                    />
                                )}
                                {step === 6 && (
                                    <DemandeDPSStep6
                                        watch1={watch1}
                                        watch2={watch2}
                                        watch3={watch3}
                                        watch4={watch4}
                                        resetForm={resetForm}
                                        demandeUpdateCode={demandeUpdateCode}
                                    />
                                )}
                            </Card.Body>

                            <Card.Footer
                                className={classNames('px-md-6 bg-body-tertiary', {
                                    'd-none': step === navItems.length,
                                    ' d-flex': step < navItems.length
                                })}
                            >
                                <IconButton
                                    variant="link"
                                    icon={isRTL ? 'chevron-right' : 'chevron-left'}
                                    iconAlign="left"
                                    transform="down-1 shrink-4"
                                    className={classNames('px-0 fw-semibold', {
                                        'd-none': step === 1
                                    })}
                                    onClick={() => {
                                        setStep(step - 1);
                                    }}
                                >
                                    Retour
                                </IconButton>
                                
                                { step === navItems.length -1 ?
                                    <IconButton
                                        variant="success"
                                        className="ms-auto px-5"
                                        icon={isRTL ? 'chevron-left' : 'chevron-right'}
                                        iconAlign="right"
                                        transform="down-1 shrink-4"
                                        onClick={avancerStep}
                                    >
                                        VALIDER
                                    </IconButton>
                                :
                                    <IconButton
                                        variant="primary"
                                        className="ms-auto px-5"
                                        icon={isRTL ? 'chevron-left' : 'chevron-right'}
                                        iconAlign="right"
                                        transform="down-1 shrink-4"
                                        onClick={avancerStep}
                                    >
                                        Suivant
                                    </IconButton>
                                }
                            </Card.Footer>
                        </Card>
                    </>);
                }else{
                    return (<>
                        <Card className="theme-wizard mt-3">
                            <Card.Header
                                className={classNames('bg-body-tertiary', {
                                    'px-4 py-3': variant === 'pills',
                                    'pb-2': !variant
                                })}
                            >
                                <center><h4 className='mb-3'>Votre demande de DPS</h4></center>
                            </Card.Header>

                            <Card.Body className="fw-normal px-md-6 py-4">
                                <Row className="justify-content-center">
                                    <Col xs={12} lg={9} xl={10} xxl={8}>
                                        <Row>
                                            <Col md>
                                                <div className="border rounded-3 overflow-hidden mb-3">
                                                    <Flex justifyContent="between" alignItems="center" className="p-4">
                                                        <div>
                                                            <h3 className="fw-light fs-4 mb-0 text-primary">Rapide</h3>
                                                        </div>
                                                        <div className="pe-3">
                                                            <FontAwesomeIcon size='xl' icon="clipboard-question" className='text-primary'/>
                                                        </div>
                                                    </Flex>
                                                    <div className="p-4 bg-body-tertiary">
                                                        <ul className="list-unstyled">
                                                            <li className={classNames('border-bottom py-2')}>
                                                                <FontAwesomeIcon
                                                                    icon="question"
                                                                    className={classNames('text-primary')}
                                                                    transform="shrink-2"
                                                                />{' '}C'est votre première demande de poste
                                                            </li>
                                                            <li className={classNames('border-bottom py-2')}>
                                                                <FontAwesomeIcon
                                                                    icon="question"
                                                                    className={classNames('text-primary')}
                                                                    transform="shrink-2"
                                                                />{' '}Vous n'avez pas encore toutes les informations sur votre évènement
                                                            </li>
                                                            <li className={classNames('border-bottom py-2')}>
                                                                <FontAwesomeIcon
                                                                    icon="question"
                                                                    className={classNames('text-primary')}
                                                                    transform="shrink-2"
                                                                />{' '}Vous souhaitez que nous remplissions la demande de poste ensemble
                                                            </li>
                                                            <li className={classNames('border-bottom py-2')}>
                                                                <FontAwesomeIcon
                                                                    icon="question"
                                                                    className={classNames('text-primary')}
                                                                    transform="shrink-2"
                                                                />{' '}Vous souhaitez échanger au sujet de votre évènement
                                                            </li>
                                                        </ul>
                                                        <Button
                                                            variant={'primary'}
                                                            className="d-block w-100"
                                                            onClick={()=>{setShowShortRequest(true);}}
                                                        >
                                                            Etre rappelé
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col md>
                                                <div className="border rounded-3 overflow-hidden mb-3 mb-md-0">
                                                    <Flex justifyContent="between" alignItems="center" className="p-4">
                                                        <div>
                                                            <h3 className="fw-light fs-4 mb-0 text-primary">Complète</h3>
                                                        </div>
                                                        <div className="pe-3">
                                                            <FontAwesomeIcon size='xl' icon="clipboard-check" className='text-primary'/>
                                                        </div>
                                                    </Flex>
                                                    <div className="p-4 bg-body-tertiary">
                                                        <ul className="list-unstyled">
                                                            <li className={classNames('border-bottom py-2')}>
                                                                <FontAwesomeIcon
                                                                    icon="check"
                                                                    className={classNames('text-primary')}
                                                                    transform="shrink-2"
                                                                />{' '}L'organisation de votre évènement est bien avancée, vous avez toutes les billes pour demande un DPS
                                                            </li>
                                                        </ul>
                                                        <Button
                                                            variant={'primary'}
                                                            className="d-block w-100"
                                                            onClick={()=>{setShowShortRequest(false);}}
                                                        >
                                                            Formulaire de demande
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </>);
                }
            }
            
        }
    }
};

export default DemandeDPS;